export default __webpack_public_path__ + "static/media/bloom-white.0fad013c.svg";